import { html } from "lit";
var icon_launch_default = () => html`
  <svg viewBox="-3 -3 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.077 3.769v1.846H1.923v18.462h18.461l.001-10.154h1.846v12H.077V3.769h12zM25.923.077v8.308h-1.846l-.001-5.157-15.038 15.04-1.306-1.306L22.771 1.923h-5.156V.077h8.308z" />
  </svg>
`;
export {
  icon_launch_default as default
};
//# sourceMappingURL=icon-launch.js.map
